<template>
  <div class="mf_dp_custom accordion" role="tablist">
    <b-card no-body class="mb-1">
      <b-card-header class="p-0" role="tab">
        <b-button
          block
          v-b-toggle="'collapse-' + this.uid"
          class="btnAccordion"
        >
          <span class="mf_dp_title">{{ title }}</span>
          <span class="when-open"><b-icon icon="chevron-up"></b-icon></span>
          <span class="when-closed"><b-icon icon="chevron-down"></b-icon></span
        ></b-button>
      </b-card-header>
      <b-collapse
        :id="'collapse-' + this.uid"
        visible
        accordion="my-accordion"
        role="tabpanel"
      >
        <b-card-body>
          <b-table
            striped
            hover
            :fields="fields"
            :items="items"
            :per-page="perPage"
            :current-page="currentPage"
            responsive="sm"
            class="mf_custom_table"
          >
            <template #head(etf)="data">
              <div class="tbHeader">
                <span class="tbHeader_label">{{ data.label }}</span>
              </div>
            </template>
            <template #head(score1)="data">
              <div class="tbHeader">
                <span class="tbHeader_label">{{ data.label }}</span>
              </div>
            </template>
            <template #head(score2)="data">
              <div class="tbHeader">
                <span class="tbHeader_label">{{ data.label }}</span>
              </div>
            </template>

            <template #cell(nom)="data">
              <span class="tb_col_etf">{{ data.item["sec"].name }} </span>
            </template>
            <template #cell(isin)="data">
              <span class="tb_col_score">{{ data.item["sec"].isin }} </span>
            </template>
            <template #cell(allocation)="data">
              <span class="tb_col_score"
                >{{ Math.round(data.item["weight"]) }}
              </span>
            </template>
            <template #cell(portefeuille)="">
              <label class="control control-checkbox">
                <input type="checkbox" checked="checked" />
                <div class="control_indicator"></div>
              </label>
            </template>
          </b-table>
          <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="my-table"
          ></b-pagination>
          <!-- Laisser le temps d'implémenter le nouveau select un peu plus jolie -->
          <!-- <CustomSelect :content="platforms" /> -->
          <AffiliationForm :platforms="platforms" />
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>
<script>
import AffiliationForm from "../../../AffiliationForm.vue";
import CustomSelect from "../../components/Select.vue";
export default {
  props: ["title", "datas", "platforms"],
  components: { AffiliationForm, CustomSelect },
  data() {
    return {
      selected: null,
      perPage: 10,
      currentPage: 1,
      items: [],
      fields: [
        { key: "nom", label: "Nom" },
        { key: "isin", label: "Code Isin" },
        { key: "allocation", label: "Allocation (%)" }
      ]
    };
  },
  mounted() {
    delete this.datas.platform;
    for (var key in this.datas) {
      this.items.push(this.datas[key]);
    }
    console.log(this.items);
  },
  computed: {
    rows() {
      return this.datas.length;
    }
  }
};
</script>
<style lang="scss">
@import "../../../../../../../resources/sass/_variables.scss";
.mf_dp_custom {
  .card {
    border-radius: 15px;
    border: none;
    background: $bg_color;
    box-shadow: $boxShadow;
    width: 80%;

    .card-header {
      border: none;
    }
  }
  .collapsed > .when-open,
  .not-collapsed > .when-closed {
    display: none;
  }
  .mf_dp_title {
    color: $purple_color;
    border-radius: 30px;
    font-weight: bold;
    font-size: 20px;
  }
  .btnAccordion {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: $bg_color;
    border: none;
    border-radius: 15px;
    width: 100%;
    padding: 15px;
    $padding: 20px;
    padding-right: $padding;
    padding-left: $padding;
    color: $purple_color;

    &:hover {
      background-color: $lt_grey_color;
    }

    &:focus,
    &:active {
      background: transparent;
      border: none;
      box-shadow: none;
      color: $purple_color;
    }

    span > svg {
      color: $purple_color;
      height: 1.8em;
      width: 1.8em;
    }
  }
  .formSelectCustom {
    border: none;
    border-radius: 15px;
    background: $bg_color;
    box-shadow: $boxShadow;
    width: 40%;
    padding: 10px;
    color: $mf_ft_color_lt;
  }
  .dp_text {
    color: $mf_ft_color_lt;
    font-weight: bold;
  }
  .btnValidation {
    background: $purple_color;
    border: none;
    border-radius: 15px;
    width: 50%;
    display: flex;
    align-items: center;
    margin: auto;
    .btnText {
      flex: 2;
    }
  }
}
</style>